import type React from 'react';

import CssBaseline from '@mui/material/CssBaseline';

import { type RouteStateModel } from '@/model/RouteState.model.ts';

export const DRAWER_WIDTH = 210;

type Props = {
  component: React.FC<{ route: RouteStateModel }>;
  route: RouteStateModel;
};

const Layout: React.FC<Props> = ({ component: Component, route }) => (
  <>
    <CssBaseline />
    <Component route={route} />
  </>
);

export default Layout;
